module.exports = __webpack_public_path__ + "img/nav-bar.01441c96.svg";